import { createVuetify } from 'vuetify'

// components & directives are auto-imported per-use by vite-plugin-vuetify
// (autoImport: true) — no need to register every component up-front.



import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

import { md3 } from 'vuetify/blueprints'

// Vuetify GLOBAL styles — REQUIRED.
// autoImport (vite-plugin-vuetify) only injects PER-COMPONENT styles
// (VBtn, VCard, …). It does NOT include the grid system
// (v-container / v-row / v-col), the helper/utility classes
// (pa-*, ma-*, d-flex, text-*, justify-*, …), the CSS reset, or the
// base body typography — all of those live in 'vuetify/styles'.
// Omitting this import is why the grid, utilities and fonts were missing.
// vite-plugin-vuetify routes this import through the configFile
// (src/assets/scss/vuetify-settings.scss), so our SCSS-variable
// overrides still apply and tree-shaking is unaffected.
import 'vuetify/styles'

import iconComputer from '../components/svgs/IconComputer.vue'
import iconEnvelope from '../components/svgs/IconEnvelope.vue'
import iconPercentage from '../components/svgs/IconPercentage.vue'
import iconCalculator from '../components/svgs/iconCalculator.vue'
import iconReview from '../components/svgs/iconReview.vue'
import iconConsider from '../components/svgs/iconConsider.vue'
import iconCheck from '../components/svgs/iconCheck.vue'

const customIcons = {
  iconComputer,
  iconEnvelope,
  iconPercentage,
  iconCalculator,
  iconReview,
  iconConsider,
  iconCheck,
}

export default createVuetify({
  blueprint: md3,
  defaults: {
    VBtn: {
      style: 'letter-spacing: 0;',
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases: {
      ...aliases,
      ...customIcons,
    },
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'light',
    variations: {
      colors: ['primary', 'secondary', 'accent', 'error', 'info', 'success', 'warning', 'surface', 'surface-bright', 'surface-light', 'surface-variant'],
      lighten: 4,
      darken: 4,
    },
    themes: {
      light: {
        colors: {
          // --- Structural brand colors ---
          background: '#efefef', //Template background 
          'on-background': '#0d2547', 

          surface: '#F1C233', //Surface color for cards, sheets
          'on-surface': '#011545',

          'surface-bright': '#123A8C', // only used in results 
          'on-surface-bright': '#FFFFFF',
          
          'surface-light': '#05163B', // all panels 
          'on-surface-light': '#FFFFFF',
          
          'surface-variant': '#12223D', // footer
          'on-surface-variant': '#FFFFFF',


          primary: '#0b409b', // ctas and icons section
          'on-primary': '#FFFFFF',
          secondary: '#144AB5', // secondary cta in results 
          'on-secondary': '#FFFFFF',
          accent: '#F1C233', // accent text in heros
          'on-accent': '#0d2547',
          // --- State-based colors ---

          

          error: '#C12327',
          info: '#9CB6DC',
          success: '#40815B',
          warning: '#FFC600',
          // --- Anchor ---
          anchor: '#0b409b', 
          white: '#FFFFFF',
          'on-white': '#000000',
          black: '#000000',
          'on-black': '#FFFFFF',

          // --- Customizer-only UI colors ---
          'customizer-background': '#F8FAFC',
          'on-customizer-background': '#0F172A',
          'customizer-surface': '#FFFFFF',
          'on-customizer-surface': '#0F172A',
          'customizer-surface-variant': '#cccccc',
          'on-customizer-surface-variant': '#334155',
          'customizer-primary': '#1E293B',
          'on-customizer-primary': '#FFFFFF',
          'customizer-secondary': '#475569',
          'on-customizer-secondary': '#FFFFFF',
          'customizer-accent': '#332c18',
          'on-customizer-accent': '#1E293B',
          'customizer-error': '#DD3333',
          'on-customizer-error': '#FFFFFF',
          'customizer-info': '#2563EB',
          'on-customizer-info': '#FFFFFF',
          'customizer-success': '#16A34A',
          'on-customizer-success': '#FFFFFF',
          'customizer-warning': '#D97706',
          'on-customizer-warning': '#FFFFFF',
        },
        variables: {
          'border-color': '#DFE1E2',
          'border-opacity': 1,
          'high-emphasis-opacity': 1,
          'medium-emphasis-opacity': 0.74,
          'disabled-opacity': 0.38,
        },
      },
    },
  },
})